/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    getAutoBanSettingData({commit, rootState}, params) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get(`/games/${gameCode}/auto-ban-setting`, params, (res) => {
            return true;
        })
    },
    editAutoBanSetting({commit, rootState}, params) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.post(`/games/${gameCode}/auto-ban-setting/edit`, params).then()
    },
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/riskManagement/autoBanSetting.js